import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";

import { Icon } from "@iconify/react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import { CardComment } from "../../../components";

import { datacomment, dataService } from "../../../models/mockdata";

// import imglogo from "../../../assets/common/logo.png";
import home_caousel_4 from "../../../assets/banner_option_7.webp";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const ManagementService = () => {
  const { t } = useTranslation();
  const { state } = useLocation();

  const { targetId } = state || {};

  const serviceRef_1 = useRef(null);
  const serviceRef_2 = useRef(null);
  const serviceRef_3 = useRef(null);

  useEffect(() => {
    if (targetId === "service_1") {
      handleScrollToRef(serviceRef_1);
    } else if (targetId === "service_2") {
      handleScrollToRef(serviceRef_2);
    } else if (targetId === "service_3") {
      handleScrollToRef(serviceRef_3);
    }
  }, [targetId]);

  const handleScrollToRef = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  const [visibleSlide, setVisibleSlide] = useState(3);
  const zoomIn = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { opacity: 1, scale: 1 },
  };

  const { ref: imgRef } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const serviceContents = [
    {
      id: 0,
      content: t(dataService[2].content_1),
    },
    {
      id: 1,
      content: t(dataService[2].content_2),
    },
    {
      id: 2,
      content: t(dataService[2].content_3),
    },
    {
      id: 3,
      content: t(dataService[2].content_4),
    },
    {
      id: 4,
      content: t(dataService[2].content_5),
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setVisibleSlide(1);
      } else {
        setVisibleSlide(2);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <div className="">
        <div className="w-full   h-[calc(100vh-132px)]  relative transition-all duration-1000 ease-in-out">
          <img
            className="w-full h-full absolute  object-cover  top-0 left-0"
            src={home_caousel_4}
          ></img>
        </div>
      </div>
      <motion.div
        initial="hidden"
        whileInView={"visible"}
        variants={fadeInUp}
        transition={{ duration: 0.5 }}
        className={
          "max-w-[1140px] mx-auto grid lg:grid-cols-2 gap-4 pt-[100px] qhd:pb-[100px] qhd:max-w-[60%] pvmax:max-dv:w-[85%]"
        }
      >
        <div
          className={"w-full flex flex-col justify-center"}
          ref={serviceRef_3}
        >
          <p
            className="pv:max-lg:text-3xl qhd:text-[2.5rem] font-bold text-[2.5rem] lg:pr-4 lg:text-2xl xl:text-3xl pb-[1.25rem] text-primary"
            style={{
              lineHeight: 1.25,
              // fontSize: "2.5rem",
              paddingBottom: "1.25rem",
            }}
          >
            {t(dataService[2].title)}
          </p>
        </div>
        <div>
          <ul className="flex flex-col ml-16 pv:max-lg:ml-0 text-xl pv:max-lg:text-lg text-primary">
            <li
              style={{ lineHeight: 1.6 }}
              className="flex text-[2rem] qhd:text-[2.5rem] pv:max-lg:text-2xl font-semibold text-primary pb-2"
            >
              {t(dataService[2].content_title)}
            </li>
            <li
              style={{ lineHeight: 1.6 }}
              className="flex text-[1.5rem] font-medium qhd:text-[2rem] pv:max-lg:text-xl pb-2 text-primary"
            >
              {t(dataService[2].content_subtitle)}
            </li>
            <li
              style={{ lineHeight: 1.6 }}
              className="flex text-justify text-[18px] pb-2 "
            >
              {t(dataService[2].content_0)}
            </li>
            {serviceContents.map((content, index) => {
              return (
                <li
                  key={index}
                  className={"flex gap-1 text-[16px]"}
                  style={{ lineHeight: 1.8 }}
                >
                  <div className="items-start mr-4">{`${index + 1}.`}</div>
                  <div className="items-start">{content.content}</div>
                </li>
              );
            })}
          </ul>
        </div>
      </motion.div>
      <motion.div
        initial="hidden"
        whileInView={"visible"}
        variants={fadeIn}
        transition={{ duration: 0.5, delay: 0.3 }}
        className="max-w-[1140px] mx-auto pv:max-md:relative pv:max-md:my-10 qhd:max-w-[60%] qhd:pb-[100px]  pv:max-md:mb-20"
      >
        <div className="pv:max-md:absolute flex pv:max-md:-bottom-20 pv:max-md:left-[calc(50%-60px)] justify-center md:justify-end pv:max-lg:pr-[7.5%] gap-4 md:pb-[4.375rem] ">
          <div className=" swiper-button-prev-custome p-2 bg-transparent border-[2px] border-primary hover:opacity-60 duration-300 flex justify-center items-center rounded-lg cursor-pointer">
            <Icon
              icon={"mingcute:arrow-left-line"}
              className="h-8 w-8 qhd:h-12 qhd:w-12 text-primary"
            ></Icon>
          </div>
          <div className="swiper-button-next-custome p-2 bg-transparent  border-[2px] border-primary hover:hover:opacity-60 duration-300 flex justify-center items-center rounded-lg cursor-pointer">
            <Icon
              icon={"mingcute:arrow-right-line"}
              className="h-8 w-8 qhd:h-12 qhd:w-12  text-primary"
            ></Icon>
          </div>
        </div>
        <Swiper
          className=" myswiper pvmax:max-lg:w-[85%] mx-auto pv:max-md:py-5"
          slidesPerView={visibleSlide}
          spaceBetween={30}
          pagination={{ el: ".swiper-pagination", clickable: true }}
          navigation={{
            nextEl: ".swiper-button-next-custome",
            prevEl: ".swiper-button-prev-custome",
            clickable: true,
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={false}
          modules={[Pagination, Navigation, Autoplay]}
        >
          {datacomment.map((item, index) => {
            return (
              <div className="" key={index}>
                <SwiperSlide className="">
                  <CardComment
                    key={index}
                    cardIndex={index}
                    avatar={item.avatar}
                    content={t(item.content)}
                    name={item.name}
                    ponsition={t(item.ponsition)}
                  ></CardComment>
                </SwiperSlide>
              </div>
            );
          })}
        </Swiper>
      </motion.div>
    </div>
  );
};

export default ManagementService;
